export default "__VITE_ASSET__4f6372f0__"